module.exports = {
	BLOCK_SIZE: 50,
};
